import LogEventMessage from 'automation-ui-log-events/components/LogEventMessage';
import LogEventStatus from 'automation-ui-log-events/components/LogEventStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HistoryEnrollmentLogEventHeader = ({
  flowObjectTypeId,
  logEvent,
  shouldTruncate
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(LogEventMessage, {
      flowObjectTypeId: flowObjectTypeId,
      logEvent: logEvent,
      shouldTruncate: shouldTruncate
    }), /*#__PURE__*/_jsx(LogEventStatus, {
      logEvent: logEvent,
      marginTop: "200"
    })]
  });
};
export default HistoryEnrollmentLogEventHeader;